/* ZIPPCART theme JS: gallery, quantity, cart drawer (Shopify AJAX Cart API), reveal, sticky bar */
(function () {
  var Z = window.ZC || {};
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  function money(cents) {
    try {
      return new Intl.NumberFormat(Z.locale || 'en-IN', { style: 'currency', currency: Z.currency || 'INR', maximumFractionDigits: 0 }).format(cents / 100);
    } catch (e) { return (cents / 100).toFixed(0); }
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* ---------- Cart drawer ---------- */
  var drawer = $('#zc-drawer');
  var body = $('#zc-drawer-body');
  var foot = $('#zc-drawer-foot');

  function openDrawer() { if (drawer) { drawer.classList.add('open'); drawer.setAttribute('aria-hidden', 'false'); } }
  function closeDrawer() { if (drawer) { drawer.classList.remove('open'); drawer.setAttribute('aria-hidden', 'true'); } }

  function setCount(n) {
    $$('[data-cart-count]').forEach(function (el) { el.textContent = n; el.hidden = n < 1; });
  }

  function render(cart) {
    setCount(cart.item_count);
    if (!body) return;
    if (!cart.items.length) {
      body.innerHTML = '<p class="empty">Your cart is empty.</p>';
      foot.hidden = true;
      return;
    }
    body.innerHTML = cart.items.map(function (it, i) {
      var img = it.image ? '<img src="' + esc(it.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x160$1$2')) + '" alt="' + esc(it.title) + '">' : '';
      var variant = it.variant_title && it.variant_title !== 'Default Title' ? '<p class="v">' + esc(it.variant_title) + '</p>' : '';
      return '<div class="line" data-line="' + (i + 1) + '">' + img +
        '<div class="info"><p class="t">' + esc(it.product_title) + '</p>' + variant +
        '<p class="p">' + money(it.final_price) + '</p>' +
        '<div class="qty"><button type="button" aria-label="Decrease" data-change="' + (it.quantity - 1) + '">' + Z.iconMinus + '</button>' +
        '<span>' + it.quantity + '</span>' +
        '<button type="button" aria-label="Increase" data-change="' + (it.quantity + 1) + '">' + Z.iconPlus + '</button></div>' +
        '<button type="button" class="rm" data-change="0">Remove</button></div></div>';
    }).join('');
    foot.hidden = false;
    $('#zc-subtotal').textContent = money(cart.original_total_price);
    var disc = cart.original_total_price - cart.total_price;
    var dRow = $('#zc-discount-row');
    if (dRow) { dRow.hidden = disc <= 0; $('#zc-discount').textContent = '-' + money(disc); }
    $('#zc-total').textContent = money(cart.total_price);
  }

  function getCart() {
    return fetch(Z.root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }
  function refresh() { return getCart().then(render); }

  function changeLine(line, qty) {
    return fetch(Z.root + 'cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty })
    }).then(function (r) { return r.json(); }).then(render);
  }

  function addToCart(id, qty) {
    return fetch(Z.root + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: qty }] })
    }).then(function (r) {
      return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Could not add to cart'); return j; });
    });
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-open-cart]');
    if (t) { e.preventDefault(); refresh(); openDrawer(); return; }
    if (e.target.closest('[data-close-cart]')) { closeDrawer(); return; }
    var ch = e.target.closest('[data-change]');
    if (ch) {
      var line = ch.closest('[data-line]');
      changeLine(Number(line.getAttribute('data-line')), Number(ch.getAttribute('data-change')));
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });

  /* ---------- Add to cart / Buy now buttons ---------- */
  function currentQty() {
    var q = $('[data-qty]');
    return q ? Number(q.textContent) || 1 : 1;
  }
  function currentVariant() {
    var sel = $('[data-variant-select]');
    if (sel) return sel.value;
    var h = $('[data-variant-id]');
    return h ? h.getAttribute('data-variant-id') : null;
  }
  $$('[data-add]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var mode = btn.getAttribute('data-add'); // "cart" or "buy"
      var fixedQty = btn.getAttribute('data-fixed-qty');
      var qty = fixedQty ? Number(fixedQty) : currentQty();
      var id = btn.getAttribute('data-id') || currentVariant();
      var err = $('#zc-err');
      if (err) err.textContent = '';
      btn.disabled = true;
      addToCart(id, qty).then(function () {
        if (mode === 'buy') { window.location.href = Z.root + 'checkout'; return; }
        return refresh().then(openDrawer);
      }).catch(function (ex) {
        if (err) err.textContent = ex.message;
        else alert(ex.message);
      }).then(function () { btn.disabled = false; });
    });
  });

  /* ---------- Quantity stepper (product page) ---------- */
  var qEl = $('[data-qty]');
  if (qEl) {
    $$('[data-qty-step]').forEach(function (b) {
      b.addEventListener('click', function () {
        var n = Number(qEl.textContent) + Number(b.getAttribute('data-qty-step'));
        qEl.textContent = Math.max(1, Math.min(10, n));
      });
    });
  }

  /* ---------- Gallery ---------- */
  var scroller = $('[data-gallery]');
  if (scroller) {
    var thumbs = $$('[data-thumb]');
    var cur = 0;
    function mark(n) { cur = n; thumbs.forEach(function (t, i) { t.classList.toggle('on', i === n); }); }
    thumbs.forEach(function (t, i) {
      t.addEventListener('click', function () {
        mark(i);
        scroller.scrollTo({ left: i * scroller.clientWidth, behavior: 'smooth' });
      });
    });
    scroller.addEventListener('scroll', function () { mark(Math.round(scroller.scrollLeft / scroller.clientWidth)); }, { passive: true });
    $$('.gal-slide', scroller).forEach(function (slide, i) {
      var img = $('img', slide);
      slide.addEventListener('mousemove', function (e) {
        if (i !== cur || !window.matchMedia('(hover:hover)').matches) return;
        var r = slide.getBoundingClientRect();
        img.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%';
        img.style.transform = 'scale(1.8)';
      });
      slide.addEventListener('mouseleave', function () { img.style.transform = ''; });
    });
  }

  /* ---------- Pincode check ---------- */
  var pinForm = $('[data-pin-form]');
  if (pinForm) {
    var pin = $('input', pinForm), msg = $('[data-pin-msg]');
    pin.addEventListener('input', function () { pin.value = pin.value.replace(/\D/g, ''); msg.hidden = true; });
    pinForm.addEventListener('submit', function (e) {
      e.preventDefault();
      msg.hidden = !/^\d{6}$/.test(pin.value);
    });
  }

  /* ---------- Sticky buy bar + WhatsApp lift ---------- */
  var heroActions = $('[data-hero-actions]');
  var sticky = $('[data-sticky-bar]');
  var wa = $('.wa');
  if (heroActions && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (en) {
      var e = en[0];
      var past = !e.isIntersecting && e.boundingClientRect.top < 0;
      if (sticky) sticky.classList.toggle('show', past);
      if (wa && sticky) wa.classList.toggle('lift', past);
    }).observe(heroActions);
  }


  /* ---------- Carousels ---------- */
  $$('[data-carousel]').forEach(function (wrap) {
    var track = $('[data-track]', wrap), items = $$('.car-item', track);
    var dots = wrap.parentNode.querySelector('[data-dots]');
    var prev = $('[data-prev]', wrap), next = $('[data-next]', wrap);
    var cur = 0, count = 1;
    function step() { return items[0] ? items[0].offsetWidth : 1; }
    function build() {
      var per = Math.max(1, Math.round(track.clientWidth / step()));
      count = Math.max(1, items.length - per + 1);
      dots.innerHTML = '';
      if (count > 1) {
        for (var i = 0; i < count; i++) {
          (function (n) {
            var b = document.createElement('button');
            b.type = 'button'; b.setAttribute('aria-label', 'Go to slide ' + (n + 1));
            b.addEventListener('click', function () { track.scrollTo({ left: n * step(), behavior: 'smooth' }); });
            dots.appendChild(b);
          })(i);
        }
      }
      mark();
    }
    function mark() {
      cur = Math.min(count - 1, Math.max(0, Math.round(track.scrollLeft / step())));
      $$('button', dots).forEach(function (b, i) { b.classList.toggle('on', i === cur); });
      if (prev) prev.disabled = cur === 0;
      if (next) next.disabled = cur >= count - 1;
    }
    if (prev) prev.addEventListener('click', function () { track.scrollTo({ left: (cur - 1) * step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollTo({ left: (cur + 1) * step(), behavior: 'smooth' }); });
    track.addEventListener('scroll', mark, { passive: true });
    window.addEventListener('resize', build);
    build();
  });


  /* ---------- Demo video: play when on screen, pause when away ---------- */
  var demo = $('[data-demo-video]');
  if (demo && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (en) {
      if (en[0].isIntersecting) { var pr = demo.play(); if (pr && pr.catch) pr.catch(function () {}); }
      else demo.pause();
    }, { threshold: 0.5 }).observe(demo);
  }

  /* ---------- Scroll reveal ---------- */
  var rev = $$('.fade-up');
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
    }, { threshold: 0.12 });
    rev.forEach(function (el) { io.observe(el); });
  } else { rev.forEach(function (el) { el.classList.add('in'); }); }

  /* keep header count in sync on load */
  if (drawer) refresh();
})();
